// src/travel-guides/guestGuidesApi.ts
import { apiClient } from "@maat/api-base";
var BASE = "/main/api/guides";
var guestGuidesApi = {
  /**
   * A flat page of published guides. Backs the per-host Guides tab
   * (`workspace_id`) and the per-destination "View all" page (`areaId`).
   *
   * `page`/`pageSize` are the platform contract; the response carries `hasMore`.
   * The legacy `limit`/`offset` are still accepted by the server so an older
   * bundle keeps working — new callers should not use them.
   */
  list: (params) => apiClient.get(BASE, { params }),
  /**
   * The guides index: a page of destination shelves, each with a preview slice
   * of that destination's guides. Pages by DESTINATION — `hasMore` means more
   * destinations, not more guides.
   */
  shelves: (params) => apiClient.get(`${BASE}/shelves`, { params }),
  /** Destination options for the browse filter, each with its guide count. */
  destinations: () => apiClient.get(`${BASE}/destinations`),
  get: (id) => apiClient.get(`${BASE}/${id}`)
};

export {
  guestGuidesApi
};
